import Card from './Card.vue';

export default Card;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/notification/blocks/card/index.ts